// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"820c2513","349":"02e46639","442":"b4ddcb44","528":"e05bdb1d","661":"21d1acda","707":"84410529","881":"82cf2eb5","882":"b563aa78","923":"6a84f5c4","940":"3f70137d"}[chunkId] + ".chunk.css";
};